import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//account
const List = Loadable(lazy(() => import("pages/account")));
const Update = Loadable(lazy(() => import("pages/account/Update")));
const Transfer = Loadable(lazy(() => import("pages/account/Transfer")));
const Deposit = Loadable(lazy(() => import("pages/account/Deposit")));
const Withdraw = Loadable(lazy(() => import("pages/account/Withdraw")));

const AccountRoutes = {
  path: "account",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <List />,
    },
    {
      path: "update/:accountId",
      element: <Update />,
    },
    {
      path: "transfer/:accountId",
      element: <Transfer />,
    },
    {
      path: "deposit/:accountId",
      element: <Deposit />,
    },
    {
      path: "withdraw/:accountId",
      element: <Withdraw />,
    },
  ],
};

export default AccountRoutes;
